import { ModalEditComponentProps } from '../../../../../../../../../../baseComponents/ModalsLayouts/types'
import { useCallback } from 'react'
import { twinFetchPostJSON } from '../../../../../../../../../../utils/globals/data'
import { useNavigate } from 'react-router'
import { customerTypes } from '@teinor/erp/types/company/customer/customerTypes'
import ModalSmallFilled from '../../../../../../../../../../baseComponents/ModalsLayouts/ModalSmallFilled'
import useTwinTranslation from '../../../../../../../../../../utils/hooks/useTwinTranslation'
import { getConfigParam } from '../../../../../../../../../../utils/reducers/getters'
import locations from '../../../../../../../../../../utils/globals/locations'


interface ModalContactB2CChangeTypeProps extends ModalContactB2CChangeTypeLogicProps { }

const ModalContactB2CChangeType: React.FC<ModalContactB2CChangeTypeProps> = ({ ...rest}) => {
    const {t} = useTwinTranslation()
    const {handleOnSubmitContactType} = useModalContactB2CChangeTypeLogic({ ...rest })
    return (
        <ModalSmallFilled opened={true} setOpened={rest.setOpened} onAccept={handleOnSubmitContactType} translations={{
                title: t('transformToCustomer', 'Transformar a cliente'),
                subtitle: t('sureTransformContactToCustomer', '¿Seguro que quieres transformar este Cliente Potencial a Cliente?'),
                buttonAccept: t('transform', 'Transformar')
            }} >
        </ModalSmallFilled>
    )
}

interface ModalContactB2CChangeTypeLogicProps extends ModalEditComponentProps {}

const useModalContactB2CChangeTypeLogic = ({ allRowData, onSubmit }: ModalContactB2CChangeTypeLogicProps) => {
    const navigate = useNavigate()
    
    const handleOnSubmitContactType = useCallback(async () => {
        const showAllCustomersTogether = getConfigParam('showAllCustomersTogether') === 'on' ? true : false 
        const result = await twinFetchPostJSON('/api/app/customer/updateCustomer', {
            id: allRowData?.id,
            customer_type: customerTypes['B2C']
        })
        if (result) {
            navigate(locations.customer + '/' +  (showAllCustomersTogether ? 'allCustomers' : 'customers') + '/' + allRowData?.id + '/main')
            onSubmit(result, {})
        }
    }, [allRowData?.id, navigate, onSubmit])

    return { handleOnSubmitContactType }
}


export default ModalContactB2CChangeType